/*
 * @Author: Wei Guojun 
 * @Date: 2021-04-09 09:52:04 
 * @Last Modified by: Wei Guojun
 * @Last Modified time: 2023-12-26 14:38:41
 */
class UTIL {
    /**
     * 设置cookie值
     * @param {*} name  cookie key
     * @param {*} value 值
     * @param {*} days 过期时间
     */
    setCookie(name, value, days = 30) {
      let exp = new Date();
      exp.setTime(exp.getTime() + days * 24 * 60 * 60 * 1000);
      document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ";path=/";
    }
  
    /**
     * 获取cookie
     * @param {*} name key
     */
    getCookie(name) {
      let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
      if (arr = document.cookie.match(reg))
        return unescape(arr[2]);
      else
        return null;
    }
  
    /**
     * 删除cookie
     * @param {*} name 
     */
    removeCookie(name) {
      let exp = new Date();
      exp.setTime(exp.getTime() - 1);
      var cval = this.getCookie(name);
      if (cval != null)
        document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    }
  
    formatTime(date, fmt) {
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      let o = {
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds()
      };
      for (let k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
          let str = o[k] + '';
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str));
        }
      }
      return fmt;
    };
  
    padLeftZero(str) {
      return ('00' + str).substring(str.length);
    }
  
    /**
     * @description:将URL后的参数转换成对象 Object
     * @param :String str
     * @return:{Object} obj
     */
    urlToObj(str) {
      var obj = {};
      var arr1 = str.split("?");
      // console.log(arr1)
      var arr2 = arr1[1].split("&");
      for (var i = 0; i < arr2.length; i++) {
        var res = arr2[i].split("=");
        obj[res[0]] = res[1];
      }
      return obj;
    }

    stringthingType(data){
      var num = 0;
      let map = ['商品','文件票件','电子产品','服装鞋帽','美妆日化','珠宝饰品','玩具乐器','易碎品','工艺品']
      num = map.indexOf(data);
      num = num == -1 ? 8 : num
      return num;
    }
    jgEnv(){
      let hostname = window.location.hostname
      const hostArr = ['u-openapi.yundasys.com','kdyduat.jxnq.net','10.20.187.36','10.20.189.191','172.20.10.12','10.20.188.13']
      const hostFlag = hostArr.some(el=>el==hostname)
      if(hostFlag){
        return "uat" // 开发环境
      }else{
        return "pro" // 生产环境
      }
    }
    getJsonValues(data,key){
      if(!data){
       return false  
      }
      let  newdata = null
      let value = '';
      try{
        newdata = JSON.parse(data).data;
        for(let i=0;i<newdata.length;i++){
          if(newdata[i].name == key){
            value = newdata[i].value;
            break;
          }
        }
      }
      catch{
        console.log("无公共配置")
      }
      return value
    }
    jgsort(sort){
      let array = [];
      switch(sort){
        case 1: array= [1,0];break;
        case 2: array= [1,1];break;
        case 3: array= [2,0];break;
        case 4: array= [2,1];break;
        case 5: array= [3,0];break;
        case 6: array= [3,1];break;
        default: array = ['','']
      }
      return array;
    }
    /*计算table高度*/
    getTableHeight(that, ele, threshold){
      let rectop = 0
      that.$nextTick(() => {
        try{
          rectop = ele.getBoundingClientRect().top
        }
        catch(err){
          console.log(err+'暂无此dom') 
        }
        let tableHeightDetil =
          window.innerHeight - rectop - threshold;
        if (tableHeightDetil <= 300) {
          that.tableHeight = 300;
        } else {
          that.tableHeight = parseInt(tableHeightDetil);
        }
      });
    }
    duplicate(arr){
      let res=new Map();
      arr.forEach(item=>{
          item.sort((a,b)=>a-b);
          res.set(item.join(),item);
      });
      return Array.from(res.values);
    }
    arrayGroup(array, subGroupLength) {
      let index = 0;
      let newArray = [];
      while(index < array.length) {
          newArray.push(array.slice(index, index += subGroupLength));
      }
      return newArray;
    }
    getlimiTime(num) {
      //创建现在的时间
      var data =  new Date(new Date().getTime()-8.64e7*num);
      //获取年
      var year = data.getFullYear();
      //获取月
      var mon = data.getMonth() + 1;
      if(mon < 10){
        mon = '0' + mon
      }
      //获取日
      var day = data.getDate();
      if(day < 10){
        day = '0' + day
      }
      return year + '-' + mon + '-' + day;
    }
    // /** localStorage  本地缓存 */
    // // 设置 存储
    // setLocalStorage(key,value){
    //   localStorage.setItem(key,value)
    // }
    // // 获取 本地缓存
    // getLocalStorage(key){
    //   return JSON.stringify(localStorage.getItem('accessToken'))
    // }
    // // 删除 本地缓存
    // delLocalStorage(key){
    //   localStorage.removeItem(key)
    // }
    loadJs(src) {
      return new Promise((resolve,reject)=>{
        let script = document.createElement('script');
        script.type = "text/javascript";
        script.src= src;
        document.body.appendChild(script);
          
        script.onload = ()=>{
          resolve();
        }
        script.onerror = ()=>{
          reject();
        }
      })
    }
    deepArray(param) {
      let newArr = param;
      newArr.sort((item1, item2) => item1.label.localeCompare(item2.label));
      //   debugger;
      newArr.forEach((element) => {
        element.children &&
          (element.children = this.deepArray(element.children));
      });
      return newArr;
    }
    delRepeatJson(arr, attrName) {
      var temp = {}; //用于name判断重复
      var result = []; //最后的新数组
      arr.forEach(function (item, index) {
          if (!temp[item[attrName]]) {
              result.push(item);
              temp[item[attrName]] = true;
          }
      });
      return result;
    }  
    // 去空格
    trimAll(ele){
      if(typeof ele === 'string'){
        return ele.split(' ').join('');    
      }else{
        console.error(`${typeof ele} is not the expected type, but the string type is expected`)
      }
    }
    //文字居中提示
    gj_message(content,time){
      if(document.getElementById("gj_message")!=null){
        document.body.removeChild(document.getElementById("gj_message"));  
      }
      let el = document.createElement('div')
      el.setAttribute("id",'gj_message');
      el.style.position = 'fixed';
      el.style.backgroundColor = 'rgba(0,0,0,.6)';
      el.style.left = "50%";
      el.style.top = "50%";
      el.style.height = 36 +'px';
      el.style.lineHeight = 36 +'px';
      el.style.paddingLeft = 16 + 'px';
      el.style.paddingRight = 16 + 'px';
      el.style.borderRadius = 8 +'px';
      el.style.transform = "translate(-50%,-50%)";
      el.style.fontSize = 14 + 'px';
      el.style.color = '#fff';
      el.innerHTML = content;
      document.body.appendChild(el);
      setTimeout(() => {
        document.body.removeChild(document.getElementById("gj_message"));    
      }, time || 1500);
    }
      
}

export default new UTIL()